import _ from 'lodash';
import { TASK_READY_TYPE_STATUS } from './task';

export const orderedAttributeList = (attributes, attributeMeta) =>
  (_.get(attributeMeta, 'attributes') &&
    _.filter(_.map(attributeMeta.attributes, attrMeta => attributes[attrMeta.code]))) ||
  [];

export const getAttributeValue = attribute => {
  switch (attribute.value_type) {
    case 'code':
      return attribute.value.name;
    case 'code_list':
      return attribute.value.map(attr => attr.name).join(', ');
    case 'value':
    default:
      return attribute.value;
  }
};

export const subNavigationOptions = propertyId => {
  const baseChoosePath = `/property/${propertyId}/details`;
  return [
    {
      title: 'General',
      path: baseChoosePath,
      regex: 'property/[0-9]*\\/details\\/?$',
    },
    {
      title: 'Exterior',
      path: `${baseChoosePath}/exterior`,
      regex: 'property/[0-9]*\\/details/exterior',
    },
    {
      title: 'Interior',
      path: `${baseChoosePath}/interior`,
      regex: 'property/[0-9]*\\/details/interior',
    },
    {
      title: 'Mechanical',
      path: `${baseChoosePath}/mechanical`,
      regex: 'property/[0-9]*\\/details/mechanical',
    },
    {
      title: 'Safety',
      path: `${baseChoosePath}/safety`,
      regex: 'property/[0-9]*\\/details/safety',
    },
  ];
};

/**
 * @type {Array}
 */
export const filterPropertyStatuses = [
  { code: 'active', name: 'Active' },
  { code: 'inactive', name: 'Inactive' },
  { code: 'pending_delete', name: 'Active Properties w/ Conflict' },
];

/**
 * @type {Object}
 */
export const propertyStatuses = {
  active: { code: 'active', name: 'Active' },
  all: { code: 'all', name: 'All Properties' },
  inactive: { code: 'inactive', name: 'Inactive' },
  pendingDelete: { code: 'pending_delete', name: 'Pending Inactive' },
};

/**
 * @type {Array}
 */
export const selectOptionsPropertyStatuses = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'pending_delete', label: 'Active Properties w/ Conflict' },
];

/**
 * @type {Array}
 */
export const selectOptionsPropertyStatusesAdmin = [
  { value: 'all', label: 'All Properties' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'pending_delete', label: 'Active Properties w/ Conflict' },
  { value: 'deleted', label: 'Deleted' },
];

/**
 * @type {Array}
 */
export const selectUpdatePropertyStatusesAdmin = [
  { value: 'active', label: 'Activate' },
  { value: 'inactive', label: 'Deactivate' },
  { value: 'deleted', label: 'Deleted' },
];

/**
 * @type {Object}
 */
export const PROPERTY_STATUSES = {
  ACTIVE: 'active',
  CONFLICT: 'pending_delete',
  INACTIVE: 'inactive',
};

export const PROPERTY_STATUSES_ADMIN = {
  ...PROPERTY_STATUSES,
  DELETED: 'deleted',
};

/**
 * @type {Array}
 */
export const PROPERTY_TASK_STATUS_OPTIONS = _.map(TASK_READY_TYPE_STATUS, status => {
  const isInProgress = _.isEqual(status, TASK_READY_TYPE_STATUS.IN_PROGRESS);
  return {
    value: status,
    label: isInProgress ? 'In Progress' : _.capitalize(status),
  };
});
